import { useVariant } from '@calendly/feature-check-react'

import {
  AI_CHAT_DISCOVERY_EXPERIMENT_KEY,
  AI_CHAT_DISCOVERY_VARIANT,
} from '../constants'
import { getAiChatDiscoveryEffectiveVariant } from '../utils'

const RIGHT_RAIL_DISCOVERY_VARIANTS = new Set([
  AI_CHAT_DISCOVERY_VARIANT.BUTTON_ONLY,
  AI_CHAT_DISCOVERY_VARIANT.TOP_BUTTON,
])

/**
 * Right-rail Ask Callie pane: `button_test_d` (FAB) and `button_test_top` (app bar).
 * Only mount/call from subtrees where {@link useAiChatDiscoveryMiEligible} is already true.
 */
export const useAiChatRightRailVariantAllowed = () => {
  const variant = useVariant(AI_CHAT_DISCOVERY_EXPERIMENT_KEY, true)
  const effectiveVariant = getAiChatDiscoveryEffectiveVariant(variant)
  return RIGHT_RAIL_DISCOVERY_VARIANTS.has(effectiveVariant)
}
